export const DEFAULT_VOICE_MESSAGES = {
  call: {
    noAgentsAvailable: "No agents available at this time.",
  },
  queue: {
    connecting: "Please wait while we connect your call.",
    waiting: "All agents are busy. Please wait while we connect your call.",
  },
  recording: {
    recordingNotice: "This call may be recorded for quality purposes.",
  },
  voicemail: {
    greeting:
      "Thank you for calling. Please leave your name, contact information, and a detailed message after the beep, and we will return your call shortly.",
  },
} as const;
